<template>
    <v-container fluid class="container-full-bg-gray">
        <v-snackbar
            v-if="screen_data"
            v-model="screen_data.snackbar.isVisible"
            :color="screen_data.snackbar.color"
            :timeout="screen_data.snackbar.timeout"
        >
            {{ screen_data.snackbar.text }}
        </v-snackbar>
        <v-dialog v-if="label_dialog && screen_data.selectedStage" v-model="label_dialog" max-width="600px">
            <v-card>
                <app-row>
                    <app-col cols="12">
                        <v-card-title class="card__headline">
                            <span>Etiqueta identificativa y ayuda al usuario</span>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-text-field
                                v-model="screen_data.selectedStage.label"
                                label="Etiqueta"
                                outlined
                                dense
                                hint="Identificador único para saltos de workflow"
                                persistent-hint
                                class="mb-3"
                            ></v-text-field>
                        </v-card-text>
                        <v-card-text>
                            <v-text-field
                                v-model="screen_data.selectedStage.nickname"
                                label="Nombre de la etapa"
                                outlined
                                dense
                                hint="Nombre mostrado en el stepper del workflow"
                                persistent-hint
                                class="mb-3"
                            ></v-text-field>
                        </v-card-text>
                        <v-card-text>
                            <v-text-field
                                v-model="screen_data.selectedStage.section_title"
                                label="Título de sección"
                                outlined
                                dense
                                hint="Título que agrupa la información extraída por esta etapa"
                                persistent-hint
                                class="mb-3"
                            ></v-text-field>
                        </v-card-text>
                        <v-card-text>
                            <v-textarea
                                v-model="screen_data.selectedStage.description"
                                label="Descripción"
                                outlined
                                dense
                                rows="3"
                                hint="Descripción mostrada al usuario sobre qué datos contiene esta sección"
                                persistent-hint
                            ></v-textarea>
                        </v-card-text>
                        <v-card-actions class="acction_btns">
                            <v-spacer></v-spacer>
                            <v-btn
                                color="primary_blue"
                                class="white--text action__btn"
                                @click="label_dialog = false"
                            >
                            Salir
                            </v-btn>
                        </v-card-actions>
                    </app-col>
                </app-row>
            </v-card>
        </v-dialog>
        <v-dialog v-if="condition_script_dialog && screen_data.selectedStage" v-model="condition_script_dialog" max-width="900px">
            <v-card>
                <app-row>
                    <app-col cols="6">
                        <v-card-title class="card__headline">
                            <span>Script de condición</span>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <WackScriptEditor
                                v-model="screen_data.selectedStage.condition_script"
                            ></WackScriptEditor>
                        </v-card-text>
                        <v-card-text>
                            <i> 
                                Devuelve True para ejecutar, False para saltar.
                            </i>
                        </v-card-text>
                    </app-col>
                    <app-col cols="6">
                        <v-card-title class="card__headline">
                            <span>Script de salto</span>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <WackScriptEditor
                                v-model="screen_data.selectedStage.jump_script"
                            ></WackScriptEditor>
                        </v-card-text>
                        <v-card-text>
                            <i> 
                                Devuelve la etiqueta de la etapa a la que saltar al finalizar la etapa (Si no existe tal etiqueta se ejecuta la siguiente etapa). Devuelve 'error' para finalizar el workflow con error. Devuelve 'waiting' para dejar el documento esperando.
                            </i>
                        </v-card-text>
                        <v-card-actions class="acction_btns">
                            <v-spacer></v-spacer>
                            <v-btn 
                                color="primary_blue"
                                class="white--text action__btn"
                                @click="condition_script_dialog = false"
                            >
                            Salir
                            </v-btn>
                        </v-card-actions>
                    </app-col>
                </app-row>
                
            </v-card>
        </v-dialog>
        <v-card class="ma-4" v-if="screen_data && screen_data.workflow">
            <!-- Cabecera -->
            <v-row class="pa-0 mx-2">
                <v-col cols="9">
                    <div class="mr-auto d-flex align-sm-center">
                        <v-btn icon @click="backToList">
                            <AppIcon :src="require('../assets/back-arrow.svg')" :size="20" :preserveColors="true"/>
                        </v-btn>
                        <h3 class="primary_blue--text ml-2">Editor de workflows</h3>
                    </div>
                </v-col>
                <template v-if="screen_data && screen_data.workflow">
                    <v-col cols="3" class="text-right">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn 
                                    class="ml-1"
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    :loading="screen_data.loadingSave"
                                    @click="save()"
                                >
                                    <AppIcon :src="require('../assets/save_invoice.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>
                                </v-btn>
                            </template>
                            <span>Guardar</span>
                        </v-tooltip>
                    </v-col>
                </template>
                <template v-else>
                    <v-progress-circular
                        indeterminate
                        class="mr-2"
                        color="primary"
                    ></v-progress-circular>
                </template>
            </v-row>
            <v-divider />
            <v-card class="py-2 pa-4">
                <v-row>
                    <v-col cols="4">
                        <v-text-field
                            v-model="screen_data.workflow.name"
                            label="Nombre del workflow"
                            outlined
                            hide-details
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <v-select
                            v-model="screen_data.workflow_input"
                            :items="[{'name':'Documento','value':'document'}, {'name':'Parámetros', 'value':'params'}]"
                            item-text="name"
                            item-value="value"
                            @change="screen_data.workflow.input_entity_type_uuid = null"
                            outlined
                            hide-details
                            label="Tipo de entrada"
                        ></v-select>
                    </v-col>
                    <v-col cols="4">
                        <v-textarea
                            v-model="screen_data.workflow.description"
                            label="Descripción del workflow"
                            outlined
                            rows="2"
                            hide-details
                            hint="Descripción que verá la IA para decidir cuándo usar este workflow"
                            persistent-hint
                        ></v-textarea>
                    </v-col>
                    <v-col cols="4" v-if="screen_data.workflow_input == 'document'">
                        <v-select
                            v-model="screen_data.workflow.default_doc_types"
                            :items="screen_data.availableTypes"
                            outlined
                            multiple
                            hide-details
                            label="Aplicar este workflow por defecto a los siguientes tipos de documento"
                        ></v-select>
                    </v-col>
                    <v-col cols="4" v-else-if="screen_data.workflow_input == 'params'">
                        <div class="d-flex align-end" style="gap: 8px;">
                            <v-select
                                v-model="screen_data.workflow.input_entity_type_uuid"
                                :items="screen_data.availableEntityTypes"
                                outlined
                                item-text="name"
                                item-value="uuid"
                                hide-details
                                label="Esquema de entrada (input)"
                                style="flex: 1;"
                            ></v-select>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        color="primary"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="createNewEntityType"
                                        class="mb-1"
                                    >
                                        <v-icon>mdi-plus-circle</v-icon>
                                    </v-btn>
                                </template>
                                <span>Crear nuevo esquema</span>
                            </v-tooltip>
                        </div>
                    </v-col>
                    <v-col cols="4">
                        <div class="d-flex align-end" style="gap: 8px;">
                            <v-select
                                v-model="screen_data.workflow.output_entity_type_uuid"
                                :items="screen_data.availableEntityTypes"
                                outlined
                                clearable
                                item-text="name"
                                item-value="uuid"
                                hide-details
                                label="Esquema de salida (output) - Opcional"
                                hint="Define qué tipo de datos devuelve el workflow"
                                persistent-hint
                                style="flex: 1;"
                            ></v-select>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        color="primary"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="createNewEntityType"
                                        class="mb-1"
                                    >
                                        <v-icon>mdi-plus-circle</v-icon>
                                    </v-btn>
                                </template>
                                <span>Crear nuevo esquema</span>
                            </v-tooltip>
                        </div>
                    </v-col>
                </v-row>
                <div>
                    <v-row>
                        <v-col>
                            <div class="workflow__cards" v-if="screen_data.workflow.stages.length"> 
                                <draggable 
                                    v-model="screen_data.workflow.stages"
                                    item-key="id"
                                    handle=".drag-handle"
                                    @end="onDragEnd"
                                    class="horizontal-drag-container"
                                >
                                    
                                    <WorkflowTemplateStageCard 
                                    v-for="(stage, index) in screen_data.workflow.stages"
                                    :key="stage.id"
                                    :last="index == screen_data.workflow.stages.length-1"
                                    :stage="stage"
                                    :available_types="screen_data.availableEntityTypes"
                                    @remove-stage="removeStage(stage)"
                                    @add-stage="screen_data.addStageDialog = true"
                                    @show-detail="showDetail(stage, index)"
                                    :showErrors="screen_data.showErrors"
                                    >
                                    <template #custom-content-left style="z-index:99">
                                        <span class="pa-2 pl-1" >
                                            <v-btn icon @click.stop="changeCheckpoint(stage,index)">
                                                <v-icon
                                                :color="stage.checkpoint?'red':''"
                                                >mdi-flag</v-icon>
                                            </v-btn>
                                        </span>
                                    </template>
                                    <template #custom-content style="z-index:99">
                                        <span class="pt-2 pr-1" >
                                            <v-btn icon @click.stop="labelDialog(stage,index)">
                                                <v-icon
                                                :color="stage.label?'primary':''"
                                                >mdi-tag</v-icon>
                                            </v-btn>
                                        </span>
                                        <span class="pt-2 pr-1" >
                                            <v-btn icon @click.stop="scriptDialog(stage,index)">
                                                <h1 v-if="!stage.has_some_script()">{}</h1>
                                                <h1 v-else style="color:var(--v-primary-base)">{*}</h1>
                                            </v-btn>
                                        </span>
                                        <span class="drag-handle"><h1>☰</h1></span>
                                    </template>
                                    
                                    
                                    </WorkflowTemplateStageCard>
                              </draggable>
                            </div>
                            <!-- <WorkflowTemplateStageCard 
                                    v-for="(stage, index) in screen_data.workflow.stages"
                                    v-bind:key="index"
                                    :index="index == screen_data.workflow.stages.length-1"
                                    :stage="stage"
                                    :available_types="screen_data.availableEntityTypes"
                                    @remove-stage="workflow_template_component.removeStage(stage)"
                                    @add-stage="screen_data.addStageDialog = true"
                                    @show-detail="showDetail(stage, index)"
                                    :showErrors="screen_data.showErrors"
                                    >
                                </WorkflowTemplateStageCard> -->
                            <v-btn 
                                v-if="screen_data.workflow.stages.length == 0"
                                icon 
                                class="ml-1" 
                                color="primary_blue" 
                                @click="screen_data.addStageDialog = true">
                                <v-icon class="material-symbols-outlined">add</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>  
                        <v-col v-if="screen_data.showStageDetails">
                            <WorkflowTemplateStageDetail 
                            :stage="screen_data.selectedStage"
                            :available_types="screen_data.availableEntityTypes"
                            :available_users="screen_data.availableUsers"
                            @close-detail="hideDetail()"
                            :showErrors="screen_data.showErrors"
                            @compute-stage="computeActualStage(screen_data.selectedStage)"
                            :my_bag="screen_data.myCurrentBagOfInstances"
                            :availableWorkflows="screen_data.availableWorkflows"
                            :key="screen_data.selectedStageIndex.toString()+screen_data.selectedStage.name">
                            </WorkflowTemplateStageDetail>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
            

        </v-card>

        <v-dialog persistent v-if="screen_data" v-model="screen_data.addStageDialog" max-width="500px">
            <v-card>
                <v-card-title class="card__headline">
                    <span>Añadir nueva etapa</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-select
                        v-model="screen_data.newStageName"
                        :items="screen_data.availableStages"
                        label="Tipo de etapa"
                        item-text="name"
                        item-value="value"
                        outlined
                        dense
                        hide-details
                        class="my-4"
                    ></v-select>
                    <!-- <v-select
                        v-if="screen_data.newStageName == 'WaitForApproval'"
                        v-model="screen_data.newStageUser"
                        :items="screen_data.availableUsers"
                        label="Usuario"
                        item-text="username"
                        item-value="username"
                        outlined
                        dense
                        hide-details
                    ></v-select> -->
                    <!-- <div v-if="screen_data.newStageName == 'AskAI'">
                        <v-text-field
                            v-model="screen_data.newStageKey"
                            label="Nombre del esquema"
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                        <v-radio-group v-model="screen_data.indicateTableKey">
                            <v-radio label="Indicar clave de tabla" value="true"></v-radio>
                            <v-radio label="No indicar clave de tabla" value="false"></v-radio>
                        </v-radio-group>
                        <v-text-field
                            v-if="screen_data.indicateTableKey == 'true'"
                            v-model="screen_data.newStageTableKey"
                            label="Clave de tabla"
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                        <div class="d-flex justify-space-between">
                            <v-checkbox
                                v-model="screen_data.newReason"
                                label="Reason"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="screen_data.newClassicRender"
                                label="Clasic Render"    
                            ></v-checkbox>
                            <v-checkbox
                                v-model="screen_data.newCheap"
                                label="Cheap"
                            ></v-checkbox>
                        </div>
                    </div> -->
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="screen_data.addStageDialog = false" class="action__btn">Cancelar</v-btn>
                    <v-btn 
                        color="primary_blue"
                        class="white--text action__btn"
                        :disabled="!canAdd()"
                        @click="actuallyAddStage()"
                    >
                    Crear
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.showErrorsDialog" class="pa-0 ma-0 rounded" width="350px">
            <v-card class="error__dialog text-center overflow-hidden">
                <v-card-title class="d-flex justify-space-between">
                    <span class="px-4">Atención</span>
                    <v-btn
                        icon
                        @click="screen_data.showErrorsDialog=false"
                    >
                        <v-icon color="white" class="material-symbols-outlined">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-6 px-12">
                    <v-row>
                        <v-col cols="12" class="d-flex flex-column">
                            <v-icon size="48" color="#DC0B0BE5" class="material-symbols-outlined">warning</v-icon>
                            <span class="text-subtitle-1 font-weight-bold">Información incompleta</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <span v-if="screen_data.workflow.stages.length == 0"> 
                                Por favor, <strong>agregue al menos una etapa</strong> al workflow.
                            </span>
                            <span v-else>Por favor, <strong>revise los campos pendientes</strong> y complete la información necesaria para poder guardar el workflow.</span>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-container>
    
</template>
  
<script>
import AppBtn from "@/components/layout/AppBtn.vue";
import AppRow from "@/components/layout/AppRow.vue";
import AppCol from "@/components/layout/AppCol.vue";
import { WorkflowTemplateEditorScreenData } from "@/modules/document/domain/WorkflowTemplateEditorScreenData";
import { WorkflowTemplateEditorComponent } from "@/modules/document/application/WorkflowTemplateEditorComponent";
import WorkflowTemplateStageCard from "@/components/WorkflowTemplateStageCard.vue";
import { ApiWorkflowTemplateRepository } from "@/modules/document/infra/ApiWorkflowTemplateRepository";
import WorkflowTemplateStageDetail from "@/components/WorkflowTemplateStageDetail.vue";
import { ApiOtherDocumentRepository } from "@/modules/document/infra/ApiOtherDocumentRepository";
import { EntityTypeApiRepository} from "@/modules/entities/infra/EntitiesApiRepositories";
import { nameToClass } from "@/modules/document/domain/WorkflowTemplate";
import Draggable from "vuedraggable";
import WackScriptEditor from "@/modules/document/infra/WackScriptEditor";
  
export default {
    name: "WorkflowEditor",
    components: {
        AppBtn,
        AppCol,
        AppRow,
        WorkflowTemplateStageCard,
        WorkflowTemplateStageDetail,
        Draggable,
        WackScriptEditor
    },
    data() {
        const screen_data = new WorkflowTemplateEditorScreenData()
        return {
            workflow_template_component: null,
            screen_data: screen_data,
            condition_script_dialog: false,
            label_dialog: false,
            
        };
    },
    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
            default: null
        },
        workflow_id:{
            type: [Number,String],
            required: false,
            default: null
        },
    },
    async mounted() {
        this.workflow_template_component = new WorkflowTemplateEditorComponent(new ApiWorkflowTemplateRepository(), this.screen_data, new ApiOtherDocumentRepository(), new EntityTypeApiRepository());
        await this.workflow_template_component.mount(this.workflow_id);
    },
    computed:{
    },
    methods: {
        createNewEntityType() {
            // Open entity type editor in a new tab
            const route = this.$router.resolve({
                name: 'entity-type-editor',
                params: { companydb_id: this.companydb_id }
            });
            window.open(route.href, '_blank');
        },
        onDragEnd(event) {
            console.log("New Order:", this.screen_data.workflow.stages);
        },
        actuallyAddStage() {
            this.workflow_template_component.addStage()
        },
        removeStage(stage) {
            if (this.screen_data.selectedStage && this.screen_data.selectedStage.id == stage.id) {
                this.hideDetail();
            }
            this.workflow_template_component.removeStage(stage);
        },
        current_bag(curr_i){
            return this.workflow_template_component.get_current_bag(curr_i)
        },
        async save(){
            await this.workflow_template_component.saveWorkflow();
            this.$router.replace({ name: 'workflow-editor', params: { 'companydb_id': this.companydb_id, 'workflow_id': this.screen_data.workflow.id } });
        },
        backToList() {
            this.$router.push({name: 'workflow-list', params: {'companydb_id': this.companydb_id}});
        },
        canAdd() {
            // if (!this.screen_data.newStageName || 
            // (
            //     this.screen_data.newStageName == 'WaitForApproval' && !this.screen_data.newStageUser
            // ) 
            
            // ) {
            //     return false;
            // }
            return true;
        },
        changeCheckpoint(stage, index) {
            stage.checkpoint = !stage.checkpoint;
        },
        scriptDialog(stage, index) {
            this.screen_data.selectedStage = stage;
            this.screen_data.selectedStageIndex = index;
            this.condition_script_dialog = true;
        },
        labelDialog(stage, index) {
            this.screen_data.selectedStage = stage;
            this.screen_data.selectedStageIndex = index;
            this.label_dialog = true;
        },
        showDetail(stage, index) {
            this.workflow_template_component.showDetail(stage, index);
        },
        hideDetail() {
            this.screen_data.showStageDetails = false;
            this.screen_data.selectedStage = null;
        },
        computeActualStage(stage) {
            stage.calculatePrice();
        }
    },
  
};
</script>

<style>
.container-full-bg-white {
    height: 100%;
    background-color: white;
    border-top-left-radius: 15px;
    position:absolute;
    overflow-y:auto;
    padding: 10px;
}
.workflow__cards {
    display: flex;
    flex-wrap: wrap;
    /*justify-content: space-around;*/
    gap: 10px;
    margin-top: 10px;
    overflow-x: auto;
    overflow-y: hidden;
}
.acction_btns {
    display: flex !important;
    justify-content: space-between !important;
    padding: 0 24px 20px;
}
.action__btn {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    border-radius: 20px;
    padding: 18px !important;
    gap: 8px;
    text-transform: capitalize;
}

.error__dialog .v-card__title {
    padding-top: 25px !important;
    padding-bottom: 25px !important;
    background-color: #DC0B0BE5 !important;
    color: white !important;
    font-family: 'Roboto', sans-serif !important;
    font-weight: 600 !important;
    font-size: 20px !important;
    line-height: 24px !important;
}

.card__headline {
    background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white);
    height: 70px;
}

.card__headline span {
    font-size: 20px;
    font-weight: 600;
    font-family: "Roboto";
    line-height: 24px;
    text-transform: capitalize;
    color: var(--v-primary_blue-base);
}
.drag-handle {
    cursor: grab;
    padding: 5px;
}
.drag-handle:active {
    cursor: grabbing;
}
.horizontal-drag-container {
    display: flex;
    flex-direction: row;  /* Arrange items in a horizontal row */
        /* Enable horizontal scrolling if needed */
  }
</style>